export default __webpack_public_path__ + "static/media/promocion.8f953e9e.svg";